import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from './error-boundary';
import Main from './components/main';
import NetworkErrorHandlerContainer from './containers/network-error-container';
import { FeatureFlagsProvider } from './modules/feature-flags/context';
import { SiteSetupContextProvider } from './modules/site-setup/helpers/site-setup-context';

const App = ({ router }) => (
  <FeatureFlagsProvider>
    <SiteSetupContextProvider>
      <ErrorBoundary>
        <Main router={router} />
      </ErrorBoundary>
    </SiteSetupContextProvider>
    <NetworkErrorHandlerContainer />
  </FeatureFlagsProvider>
);

App.propTypes = {
  router: PropTypes.object.isRequired,
};

export default App;
